import type { CollectableItem } from "../collectableItem";
import { deserializeItem, deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { LootBox } from "./lootBox";

export class MedicalLootBox extends LootBox {
	static key = "MedicalLootBox";
	constructor(xy: XY, loot?: CollectableItem[]) {
		super(xy, loot);
	}

	static deserialize(data: any): MedicalLootBox {
		const box = new MedicalLootBox(deserializeXY(data.xy));
		box.visualId = data.visualId;
		if (data.loot) {
			box.loot = data.loot.map((d: any) => deserializeItem(d));
		}
		return box;
	}
}
